import React, { useEffect, useState } from "react";
import "./OfflineBanner.css";

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);

    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="offline-banner-floating">
      <span> No Internet Connection</span>

      <button
        className="offline-refresh-btn"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  );
}
